import React from 'react'
import ReactDOM from 'react-dom'
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { OidcProvider } from 'redux-oidc'

import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import configureStore, { history } from './redux/store'
import userManager from './utils/userManager'

const store = configureStore({});

ReactDOM.render(
  <Provider store={ store } >
    <OidcProvider store={ store } userManager={ userManager } >
      <ConnectedRouter history={ history }>
        <App />
      </ConnectedRouter>
    </OidcProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
